// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1Pdfu","excellentWrap":"_1PCVQ","excellentText":"_1couw","review":"_3tlU3","trustpilot":"MD0kk"};